<template>
  <div class="matches-layout">
    <!--m-widget-head class="upcoming-widget-head" id="upcoming-widget-head">
      <time-filter :hours="hours" :suite="[ 0, 1, 3, 6, 12, 24, 48 ]" @change="changeTimeFilterValue" / >
      <template slot="right">
        <div class="slider-container flex">
          <div class="slider-content-container flex" :style="{ width: slider.width + 'px' }">
            <div class="slider-content flex" :style="{ 'margin-right': slider.margin + 'px' }">
              <active-button
                v-for="sport in sports"
                :key="sport.id"
                line-color="blue"
                :active="$route.params.sport == sport.id"
                :title="sport.name"
                @click="$router.push(`/live/upcoming/sport/${sport.id}`)"
              >
                <sport-icon-liga-white :name="sport.alias"></sport-icon-liga-white>
              </active-button>
            </div>
          </div>
          <icon-button class="slider-toggler" @click="slide" v-if="slider.active">
            <i-arrow class="slider-toggler-icon" :class="{ left: slider.left }" />
          </icon-button>
          <active-button
            line-color="blue"
            :active="!$route.params.sport"
            :title="$t('common.all-sports')"
            @click="$router.push('/live/upcoming')"
          >
            <span>{{$t('icons.all')}}</span>
          </active-button>
        </div>
      </template>
    </m-widget-head -->
    <div class="live-upcoming-layout">
      <m-scrollbar id="live-upcoming-scrollbar">
        <match-list />
      </m-scrollbar>
    </div>
  </div>
</template>

<script>
import IArrow from 'vue-material-design-icons/ChevronLeft'
import IconButton from '@/components/buttons/IconButton'
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import TimeFilter from '@/components/TimeFilter'
import MatchList from '@/components/live/upcoming/List'
import { mapState } from 'vuex'

export default {
  components: {
    IArrow,
    IconButton,
    ActiveButton,
    SportIconLigaWhite,
    MScrollbar,
    MWidgetHead,
    TimeFilter,
    MatchList
  },
  computed: {
    ...mapState({
      hours: state => state.live.upcoming.hours,
      sports: state => state.live.upcoming.sports
    })
  },
  data () {
    return {
      slider: {
        width: 0,
        margin: 0,
        left: false,
        active: false
      }
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('live/GET_UPCOMING')
    },
    'sports.length' (to, from) {
      let init = () => {
        this.initSlider()
      }
      setTimeout(function () {
        init()
      }, 100)
    }
  },
  mounted () {
    this.initSlider()
    this.$store.dispatch('live/GET_UPCOMING')
  },
  updated () {
    let scrollbar = document.querySelector('#live-upcoming-scrollbar')
    if (!scrollbar) return

    let list = scrollbar.querySelector('.live-upcoming-list')
    if (!list) return

    let scrollTop = list.clientHeight - scrollbar.clientHeight
    if (scrollbar.scrollTop > scrollTop) {
      scrollbar.scrollTop = scrollTop
    }
  },
  beforeDestroy () {
    this.$store.commit('live/CLEAR_UPCOMING')
  },
  methods: {
    changeTimeFilterValue (hours) {
      this.$store.commit('live/SET_UPCOMING_TIME_FILTER_VALUE', hours)
    },
    slide () {
      let step = 80
      let width = document.querySelector('#upcoming-widget-head .slider-content').clientWidth - this.slider.width
      if (this.slider.left) {
        if (Math.abs(this.slider.margin - step) > width) {
          this.slider.margin = -width
        } else {
          this.slider.margin = this.slider.margin - step
        }
        if (Math.abs(this.slider.margin) === width) {
          this.slider.left = !this.slider.left
        }
      } else {
        if (this.slider.margin + step > 0) {
          this.slider.margin = 0
        } else {
          this.slider.margin = this.slider.margin + step
        }
        if (this.slider.margin === 0) {
          this.slider.left = !this.slider.left
        }
      }
    },
    initSlider () {
      let contentWidth = document.querySelector('#upcoming-widget-head .slider-content').clientWidth
      let width = document.querySelector('#upcoming-widget-head').clientWidth - document.querySelector('#upcoming-widget-head .left-widget-head').clientWidth - 100
      width = width - (width % 40)
      this.slider.width = contentWidth > width ? width : contentWidth
      this.slider.active = contentWidth > width
      if (contentWidth > width) {
        this.slider.margin = width - contentWidth
      }
    },
    handleResize () {
      this.initSlider()
    }
  }
}
</script>

<style scoped>
.matches-layout { height: 100%; margin-top: -35px; padding-top: 40px; }
.live-upcoming-layout { height: 100%; margin-top: -40px; padding: 50px 0 10px; }
.upcoming-widget-head { margin: 0 10px; }

.slider-container { flex-direction: row-reverse; }
.slider-container .active-button { height: 40px; padding: 10px; width: 40px; }
.slider-content-container { flex-direction: row-reverse; height: 40px; overflow: hidden; position: relative; }
.slider-content { -webkit-transition: margin 0.3s; -moz-transition: margin 0.3s; -o-transition: margin 0.3s; transition: margin 0.3s; }

.slider-toggler { width: 40px; }
.slider-toggler-icon { color: #fff; font-size: 24px; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; -o-transition: all 0.3s; transition: all 0.3s; }
.slider-toggler-icon.left { margin-top: 11px; -webkit-transform: rotate(-180deg); -moz-transform: rotate(-180deg); -o-transform: rotate(-180deg); transform: rotate(-180deg); }
</style>



// WEBPACK FOOTER //
// src/components/live/upcoming/View.vue